import { withModalProvider } from "../../hoc/withModalProvider";

import { SliderQuestionModal as View, IProps } from "./SliderQuestionModal";

export const SliderQuestionModal = withModalProvider<IProps>(View);
